<template>
  <div :class="{ 'invalid': !isValid, 'valid': isValid}">
    <label :for="name">{{label}}</label>
    <div v-if="!isValid" class="error">{{ errorDescription }}</div>
    <div class="dynamic-inputs flex-col" ref="scrollable" v-click-outside="closeComplete">
      <VerticalStepBullets class="steps-bullets" :totalSteps="newSteps.length" :currentStep="newSteps.length" />
      <draggable :list="newSteps" class="steps-list" :move="checkMove" @start="drag=true" @end="drag=true">
        <div 
          class="step-group group-w-button no-margin draggable-row"
          v-for="(step, index) in newSteps" 
          :key="index"
        >
          <input 
            autocomplete="off" 
            :class="{'autocomplete-active': autocompleteIndex == index}" 
            type="text" 
            :name="`newsteps[${index}][name]`" 
            v-model="step.name" 
            placeholder="Search" 
            @input="updateSteps(index)" 
            @focus="openComplete(index)"
            @keyup.enter="gotSelectionStep(stepsResult[0])"
          />
          <input autocomplete="off" type="text" :name="`newsteps[${index}][id]`" v-model="step.id" style="display:none;" /> 
          <BaseIcon name="times-circle" class="icon ico-delete" :class="{'delete-disabled': newSteps.length == 1}" @click.native="removeStep(index)"/>
          <BaseIcon name="bars" class="icon ico-move " :class="{'autocomplete-active': autocompleteIndex == index}"/>

          <AutocompleteList v-if="autocompleteIndex == index && stepsResult.length > 0" :searchResults="stepsResult" @selectedStep="gotSelectionStep" name="stepSelector"/>
        </div>
        <div class="add-step-button" @click="addNewStep">
          <BaseIcon name="plus-circle" class="icon" />
          <label>Add production step</label>  
        </div>
      </draggable>
    </div>
  </div>
</template>

<script>
  import BaseIcon from "@/components/base/Icon";
  import InputDash from "@/components/base/InputDash";
  import VerticalStepBullets from "@/components/base/VerticalStepBullets";
  import AutocompleteList from "@/components/base/AutocompleteList";
  import draggable from 'vuedraggable'

  export default {
    components: {
      BaseIcon, 
      InputDash,
      draggable,
      VerticalStepBullets,
      AutocompleteList
    },
    props: {
      label: String,
      name: String,
      value: String,
      isTextArea: Boolean,
      isDisabled: Boolean,
      placeholder: String,
      value: String
    },
    data() {
      return {
        stepsResult:[],
        newSteps: 
        [
          {
            id: '',
            name: '',
            order: ''
          },
          {
            id: '',
            name: '',
            order: ''
          },          
          {
            id: '',
            name: '',
            order: ''
          },
          {
            id: '',
            name: '',
            order: ''
          },
          {
            id: '',
            name: '',
            order: ''
          }
        ],
        autocompleteIndex: 99999,
        isValid: true,
        currentSelected: null,
        errorDescription: 'Test can not be empty',
      }
    }, 
    mounted() {
    },
    methods: {
      checkMove: function(e) {
        window.console.log("Future index: " + e.draggedContext.futureIndex);
      },
      addNewStep() {
        this.newSteps.push({
          id: '',
          name: '',
          order: ''
        })
        this.scrollToEnd()
      },
      updateSteps(index) {
        this.getSteps(index)
        this.$emit('updateSteps', this.newSteps)
        this.scrollToEnd()
      },
      scrollToEnd() {
        var container = this.$refs.scrollable
        container.scrollTop = container.scrollHeight + 84;
      },
      getSteps(index) {
        var that = this
        if (this.newSteps[index].name != "") {
          this.$http.get(this.$endpoint + 'management/productionStep/search/' + this.newSteps[index].name)
          .then(response => {
            that.stepsResult = response.data
          })
          .catch(error => {
            if (error.response.status === 401) {
              this.$store
              .dispatch("logout")
              .then(() => this.$router.push("/login"))
              .catch(err => console.log(err));
            } else {
              that.$swal(
                'Oops that went wrong?',
                `Please contact the admin with the following info: ${ error }`,
                'error'
              );
            }
          })
        }
      },
      removeStep(index) {
        if (this.newSteps.length > 1) {
          this.newSteps.splice(index, 1);
        }
      },
      openComplete(index) {
        this.autocompleteIndex = index
      },
      closeComplete(){
        this.resetAutocompleteIndex()
        this.stepsResult = []
      },
      resetAutocompleteIndex(){
        this.autocompleteIndex = 99999
      },
      selectionUp(){
        if(this.currentSelected > 0){
          this.currentSelected -= 1
        }
        this.newSteps[this.autocompleteIndex].id = this.stepsResult[this.currentSelected].stepID
        this.newSteps[this.autocompleteIndex].name = this.stepsResult[this.currentSelected].name
      },
      selectionDown() {
        if(this.currentSelected >= 0){
          this.currentSelected += 1
        } else {
          this.currentSelected = 0
        }
        this.newSteps[this.autocompleteIndex].id = this.stepsResult[this.currentSelected].stepID
        this.newSteps[this.autocompleteIndex].name = this.stepsResult[this.currentSelected].name
      },
      gotSelectionStep(selectedStep) {
        this.newSteps[this.autocompleteIndex].order = this.autocompleteIndex+1
        this.newSteps[this.autocompleteIndex].id = selectedStep.stepID
        this.newSteps[this.autocompleteIndex].name = selectedStep.name
        
        this.resetAutocompleteIndex()
        this.stepsResult = []
      },
      // sumbitForm() {
      //   const data = {
      //     newSteps: this.newSteps
      //   }
      //   alert(JSON.stringify(data, null, 2))
      // }
    },
  }
</script>

<style lang="scss" scoped>
@import "@/style/base";
@import "@/style/components/buttons";
@import "@/style/components/modals";
@import "@/style/components/dynamicInputList";

::placeholder{
  color: #EFEFEF;
}

.draggable-row{
  transform: none !important;
}

.select-autocomplete {
  max-height: 200px;
}
</style>
